import { useState } from "react";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";

export type PanVerificationStatus = "Valid" | "Invalid";

export type PanVerificationResult = {
  pan: string;
  status: PanVerificationStatus;
};

export function useVerifyPan() {
  const [isVerifyingPan, setIsVerifyingPan] = useState(false);
  const [panVerification, setPanVerification] =
    useState<PanVerificationResult | null>(null);

  const verifyPan = async (pan: string): Promise<PanVerificationResult> => {
    setIsVerifyingPan(true);
    try {
      const response = await CampaignService.verifyPan(pan);
      const result = response.data;
      setPanVerification(result);
      return result;
    } catch (err: unknown) {
      setPanVerification(null);
      let message = "Failed to verify PAN";
      try {
        const response = (
          err as { response?: { json: () => Promise<{ msg?: string }> } }
        ).response;
        if (response) {
          const body = await response.json();
          message = body?.msg || message;
        }
      } catch {
        // keep default message
      }
      ToastService.error(message);
      throw err;
    } finally {
      setIsVerifyingPan(false);
    }
  };

  const resetPanVerification = () => setPanVerification(null);

  return {
    verifyPan,
    isVerifyingPan,
    panVerification,
    resetPanVerification,
  };
}
